var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { type, defaultValue, Component, Schema } from "./decorators/type.js";
import { Vector2dSchema } from "./utils/vector.js";
import { d as CollisionCategoryEnum } from "./enums-86f58524.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let RigidBoxSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "width");
    __publicField(this, "height");
    __publicField(this, "bodyId");
    __publicField(this, "isStatic");
    __publicField(this, "isSensor");
    __publicField(this, "restitution");
    __publicField(this, "mass");
    __publicField(this, "angle");
    __publicField(this, "disabled");
    __publicField(this, "point");
    __publicField(this, "velocityLock");
    __publicField(this, "directionLock");
    __publicField(this, "collisionCategory");
    __publicField(this, "collisionMask");
    __publicField(this, "collisionEvents");
  }
};
__decorateClass([
  type("number")
], RigidBoxSchema.prototype, "width", 2);
__decorateClass([
  type("number")
], RigidBoxSchema.prototype, "height", 2);
__decorateClass([
  type("number")
], RigidBoxSchema.prototype, "bodyId", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidBoxSchema.prototype, "isStatic", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidBoxSchema.prototype, "isSensor", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], RigidBoxSchema.prototype, "restitution", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], RigidBoxSchema.prototype, "mass", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], RigidBoxSchema.prototype, "angle", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidBoxSchema.prototype, "disabled", 2);
__decorateClass([
  type(Vector2dSchema),
  defaultValue({ x: 0, y: 0 })
], RigidBoxSchema.prototype, "point", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidBoxSchema.prototype, "velocityLock", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidBoxSchema.prototype, "directionLock", 2);
__decorateClass([
  type(CollisionCategoryEnum),
  defaultValue(CollisionCategoryEnum.DEFAULT)
], RigidBoxSchema.prototype, "collisionCategory", 2);
__decorateClass([
  type(["number"])
], RigidBoxSchema.prototype, "collisionMask", 2);
__decorateClass([
  type("boolean"),
  defaultValue(false)
], RigidBoxSchema.prototype, "collisionEvents", 2);
RigidBoxSchema = __decorateClass([
  Component("RigidBox")
], RigidBoxSchema);
let RigidBoxResolverSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "bodyId");
  }
};
__decorateClass([
  type("number")
], RigidBoxResolverSchema.prototype, "bodyId", 2);
RigidBoxResolverSchema = __decorateClass([
  Component("RigidBoxResolver")
], RigidBoxResolverSchema);
const __vite_glob_0_21 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get RigidBoxResolverSchema() {
    return RigidBoxResolverSchema;
  },
  get RigidBoxSchema() {
    return RigidBoxSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  RigidBoxSchema as R,
  __vite_glob_0_21 as _,
  RigidBoxResolverSchema as a
};
//# sourceMappingURL=RigidBox-423b8c11.js.map
